
import { Options, Vue } from 'vue-class-component';
import { ContextType, CourseInfo, Team } from '@/models/CourseInfo';

@Options({
  props: {
    course: Object,
    canEdit: Boolean
  }
})
export default class TeamList extends Vue {
  course!: CourseInfo;
  ContextType = ContextType;
  canEdit = false;

  newTeam(): void {
      const team: Team = {
          name: this.course.name,
          contexts: [{ type: ContextType.Course, id: -1 }],
          channels: [],
          allowChannels: true,
          allowPrivateChannels: true,
          addAllLecturers: true,
          createSectionChannels: false,
          groupSetIds: [],
          isMember: false
      }
      this.$emit('edit', team);
  }
}
